import { render, staticRenderFns } from "./blankPage.vue?vue&type=template&id=49b898f7&"
import script from "./blankPage.vue?vue&type=script&lang=js&"
export * from "./blankPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports